import styled, { css } from 'styled-components';
import { media } from 'app/styles/variables';
import { SpanTypography } from 'app/shared/components/Typography/SpanTypography';

interface SliderButtonStProps {
  right?: boolean;
  visible: boolean;
  withBackground: boolean;
  fullscreen?: boolean;
}

const SliderButtonSt = styled.button<SliderButtonStProps>`
  position: absolute;
  z-index: 4;
  top: 50%;
  left: ${({ withBackground }) => (!withBackground ? '1rem' : '0.625rem')};
  width: 2rem;
  height: 2rem;
  display: ${({ visible }) => (visible ? 'flex' : 'none !important')};
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 100%;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.white};
  font-size: 5em;
  transform: translateY(-50%);
  background-color: rgba(48, 48, 48, 0.7);
  padding: 0;

  ${media.sm(css<SliderButtonStProps>`
    left: ${({ withBackground }) => (!withBackground ? '1.75rem' : '1rem')};
    width: ${({ withBackground }) => (!withBackground ? '3rem' : '2rem')};
    height: ${({ withBackground }) => (!withBackground ? '3rem' : '2rem')};
  `)};

  @media (hover: hover) and (pointer: fine) {
    display: ${({ withBackground }) => withBackground && 'none'};
  }

  :hover {
    background-color: rgba(48, 48, 48, 0.9);
  }

  & > img {
    width: 1rem;
    height: 1rem;
  }
`;

export const BottomControlsWrapperSt = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  z-index: 1;
  justify-content: flex-end;
  width: 100%;
  height: 1.5rem;
  gap: 1rem;
`;

export const LeftButtonSt = styled(SliderButtonSt)`
  display: ${({ fullscreen }) => (fullscreen ? 'none' : 'visible')};
  ${media.sm(
    css<SliderButtonStProps>`
      display: flex;
    `,
  )}
`;

export const RightButtonSt = styled(SliderButtonSt)`
  right: ${({ withBackground }) => (!withBackground ? '1rem' : '0.625rem')};
  left: auto;
  cursor: pointer;
  display: ${({ fullscreen }) => (fullscreen ? 'none' : 'visible')};
  ${media.sm(css<SliderButtonStProps>`
    right: ${({ withBackground }) => (!withBackground ? '1.75rem' : '1rem')};
    display: flex;
  `)};
`;

export const SlidePositionIndicatorSt = styled(SpanTypography).attrs({
  variant: 'caption2',
})`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 1;
  padding: 0 1rem;
`;
